export default "__VITE_ASSET__26b4e241__"